const getOperatorPresenceResponse = (response) => {
  return {
    ...response?.data,
    attendanceReports: response?.data?.attendanceReports.map((report) => {
      const isViolated = report?.clockInOutViolation?.isViolatedClockIn || report?.clockInOutViolation?.isViolatedClockOut;
      const reason = report?.clockInOutViolation?.reason ?? '-';

      return {
        rawData: report,
        id: report.id,
        date: report.date || '-',
        shiftName: report?.shiftName || '-',
        clockInTime: report?.clockInTime || '-',
        clockOutTime: report?.clockOutTime || '-',
        totalBreakViolations: report?.totalBreakViolations || '-',
        totalCameraViolations: report?.totalCameraViolations || '-',
        clockInOutViolation: { isViolated, reason },
      };
    }),
  };
};

export default getOperatorPresenceResponse;
